import React from 'react';
import { DropdownButton, MenuItem } from 'ui';

/**
 * Dropdown button for adding filter types to the Code Modal filter UI.
 *
 * @param {Object} props
 * @param {Array<Object>} props.availableFilters - Array of filter options, each with { id, name }
 * @param {Array<string>} props.activeFilterIds - IDs of filters currently shown (will be disabled)
 * @param {Function} props.onAddFilter - Callback when a filter is selected: (filterId) => void
 */
const AddFilterDropdownButton = ({
  availableFilters = [],
  activeFilterIds = [],
  onAddFilter
}) => {
  const handleSelect = (filterId) => {
    if (!activeFilterIds.includes(filterId) && onAddFilter) {
      onAddFilter(filterId);
    }
  };

  const menuItems = availableFilters.map((filter) => {
    const isActive = activeFilterIds.includes(filter.id);

    return (
      <MenuItem
        key={filter.id}
        onClick={() => handleSelect(filter.id)}
        eventKey={filter.id}
        disabled={isActive}
      >
        {filter.name}
      </MenuItem>
    );
  });

  return (
    <DropdownButton
      variant="link"
      title="Add Filter"
      id="code-modal-add-filter-dropdown"
    >
      {menuItems}
    </DropdownButton>
  );
};

export default AddFilterDropdownButton;
